<template>
    <rd-card type="vertical" margins="none">
        <rd-card-header>
            <rd-header :title="$t('dashboard.monthlyLimits.title')" margins="none" size="medium" />
        </rd-card-header>
        <rd-card-content>
            <dx-data-grid :data-source="limitsDataSource"
                          height="180"
                          :scrolling="scrollingSettings">
                <dx-column :caption="$t('dashboard.monthlyLimits.captions.department')"
                           data-type="string"
                           data-field="DepartmentName" />
                <dx-column :caption="$t('dashboard.monthlyLimits.captions.limit')"
                           data-type="string"
                           data-field="Value">
                    <dx-format type="fixedPoint"
                               :precision="2" />
                </dx-column>
                <dx-column :caption="$t('dashboard.monthlyLimits.captions.used')"
                           data-type="string"
                           data-field="ActualValue">
                    <dx-format type="fixedPoint"
                               :precision="2" />
                </dx-column>
                <dx-paging :enabled="true" :page-size="5"></dx-paging>
            </dx-data-grid>
        </rd-card-content>
    </rd-card>
</template>

<script>
    // @ is an alias to /src
    import { mapState, mapActions } from 'vuex';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    import { DxDataGrid, DxColumn, DxFormat, DxPaging } from 'devextreme-vue/data-grid'

    const name = "processesStores/pzzDashboardStores/indexStore";

    export default {
        name: 'pzzDashboardDepartmentMothlyLimits',
        created() {
            this.setLimitsDataSource();
        },
        data() {
            return {
                scrollingSettings: {
                    mode: 'virtual',
                    showScrollbar: 'always' 
                }
            }
        },
        computed: {
            ...mapState(name, ['limitsDataSource'])
        },
        methods: {
            ...mapActions(name, ['setLimitsDataSource'])
        },
        components: {
            DxDataGrid,
            DxColumn,
            DxFormat,
            DxPaging
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>
